import React from 'react';
import Header from './Header';
import AdminNav from '../Navigation/AdminNav';
import Footer from './Footer';
import styles from './styles/Layout.module.css';

export default function Layout({ children }) {
    return (
        <div className={styles.layout}>
            <Header />
            <AdminNav /> {/* Navigation Admin */}
            <main className={styles.main}>
                {children}
            </main>
            <Footer />
        </div>
    );
}
